export default __webpack_public_path__ + "static/media/letter_hi.0a070ed4.jpg";